import { TsDOM as q} from '@/scripts/core/TsDOM'
import { DeferredMedia } from '@/scripts/theme/deferred-media'
import { DetailsDisclosure } from '@/scripts/theme/details-disclosure'
import { SliderComponent } from '@/scripts/theme/slider-component'
import { SlideshowComponent } from '@/scripts/theme/slideshow-component'
import {
	lockHeaderDrawerScroll,
	startAccountTriggerPartSync,
	StickyHeader,
} from '@/scripts/theme/sticky-header'
import { UcoastVideo } from '@/scripts/core/ucoast-video';
import { WaitlistForm } from '@/scripts/theme/waitlist-form'
import { KlaviyoForm } from '@/scripts/theme/klaviyo-form'
import { WelcomePopup } from '@/scripts/theme/welcome-popup'
import { CartNotification } from '@/scripts/theme/cart-notification'
import { StandardViewEventElement } from '@/scripts/platform/standard-events'
import { refreshCartSectionsForStandardAction } from '@/scripts/platform/standard-actions'

import { FaqAccordions } from '@/scripts/theme/faq-accordions';
import { HeroFeaturedProduct } from '@/scripts/theme/hero-featured-product';
import { ClinicalResults } from '@/scripts/theme/clinical-results';
import { IngredientsList } from '@/scripts/theme/ingredients-list';
import { GalleryCarousel } from '@/scripts/theme/gallery-carousel';
q.safeDefineElement(UcoastVideo)
q.safeDefineElement(DeferredMedia)
q.safeDefineElement(SliderComponent)
q.safeDefineElement(SlideshowComponent)
lockHeaderDrawerScroll()
startAccountTriggerPartSync()
q.safeDefineElement(StickyHeader)
q.safeDefineElement(DetailsDisclosure)
q.safeDefineElement(KlaviyoForm)
q.safeDefineElement(WelcomePopup)
q.safeDefineElement(WaitlistForm)
q.safeDefineElement(CartNotification)
q.safeDefineElement(FaqAccordions)
q.safeDefineElement(HeroFeaturedProduct)
q.safeDefineElement(ClinicalResults)
q.safeDefineElement(IngredientsList)
q.safeDefineElement(GalleryCarousel)
if (!customElements.get('s-view-event')) {
	customElements.define('s-view-event', StandardViewEventElement)
}
window.Ucoast.refreshCartSections = refreshCartSectionsForStandardAction
